import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, initialAuthState } from './auth.state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuthLoginId = createSelector(
  selectAuthState,
  (state) => state?.loginId ?? null,
);

export const selectAuthUser = createSelector(
  selectAuthState,
  (state) => state?.fullName ?? initialAuthState.fullName,
);

export const getUserRoles = createSelector(
  selectAuthState,
  (state) => state?.roles ?? [],
);

export const selectAuthError = createSelector(
  selectAuthState,
  (state) => state?.error ?? initialAuthState.error,
);

export const selectAuthLoading = createSelector(
  selectAuthState,
  (state) => !(state?.loaded ?? initialAuthState.loaded),
);

export const getAccessToken = createSelector(
  selectAuthState,
  (state) => state?.token,
);

export const getRefreshToken = createSelector(
  selectAuthState,
  (state) => state?.refreshToken,
);

export const selectUserFullName = createSelector(
  selectAuthState,
  (state) => state?.fullName ?? '',
);

export const selectCurrentCompany = createSelector(
  selectAuthState,
  (state) => state?.company ?? null,
);

export const selectAllowedHotels = createSelector(
  selectAuthState,
  (state) => state?.allowedHotels ?? [],
);

export const selectCurrentHotelId = createSelector(
  selectCurrentCompany,
  (company) => company?.hotelId ?? null,
);

export const getModules = createSelector(
  selectAuthState,
  (state) => state?.modules ?? [],
);
